// extracted by mini-css-extract-plugin
export default {"container":"LanguageControl_container__-UQVZ","select_block":"LanguageControl_select_block__YG9Hx","select":"LanguageControl_select__YZXaG"};